<template>
	<div class="content-wrapper">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb breadcrumb-centered">
				<li class="breadcrumb-item">
					<a href="#">
						<i class="fa fa-home"></i>
						Dashboard
					</a>
				</li>
				<li class="breadcrumb-item">
					<a href="#">
						<i class="fa fa-file-alt"></i>
						Reports
					</a>
				</li>
				<li class="breadcrumb-item active">TDS Report</li>
				<li class="breadcrumb-right" v-if="meta.totals">
					<div class="d-flex flex-wrap align-items-center" style="gap: 25px;">
						<div class="total-item">
							<div class="total-label">BuyIn</div>
							<div class="total-value">{{ formatAmount(meta.totals.buy_in) }}</div>
						</div>
						<div class="total-item">
							<div class="total-label">Deposit</div>
							<div class="total-value">{{ formatAmount(meta.totals.deposit) }}</div>
						</div>
						<div class="total-item">
							<div class="total-label">Withdraw</div>
							<div class="total-value">{{ formatAmount(meta.totals.withdraw) }}</div>
						</div>
						<div class="total-item">
							<div class="total-label">CashOut</div>
							<div class="total-value">{{ formatAmount(meta.totals.cash_out) }}</div>
						</div>
						<div class="total-item">
							<div class="total-label">TDS Applicable</div>
							<div class="total-value text-warning">{{ formatAmount(meta.totals.tds_applicable_amount) }}
							</div>
						</div>
						<div class="total-item">
							<div class="total-label">TDS</div>
							<div class="total-value text-danger">{{ formatAmount(meta.totals.tds) }}</div>
						</div>
					</div>
				</li>
			</ol>
		</nav>
		<section class="content">
			<div class="container-fluid">
				<div class="row justify-content-md-center">
					<div class="col-sm-12">
						<div class="card">
							<div class="card-header">
								<h3 class="card-title">TDS Report</h3>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="col-sm-3" v-can="'change_branch'">
										<div class="form-group">
											<label for="branch_id">Branch *</label>
											<select class="form-control form-control-sm"
												:class="{ 'is-invalid': errors.branch_id }" v-model="meta.branch_id"
												@change="onBranchChange" required>
												<option value="">Select Branch</option>
												<option v-for="branch in branches" :key="branch.branch_id"
													:value="branch.branch_id">
													{{ branch.branch_name }}
												</option>
											</select>
											<span v-if="errors.branch_id" class="invalid-feedback">{{
												errors.branch_id[0] }}</span>
										</div>
									</div>
									<div class="col-sm-3">
										<div class="form-group">
											<label for="session_log_id">Session *</label>
											<select class="form-control form-control-sm"
												:class="{ 'is-invalid': errors.session_log_id }"
												v-model="meta.session_log_id" @change="onSessionChange" required>
												<option value="">Select Session</option>
												<option v-for="(session_log, key) in session_logs" :key="key"
													:value="session_log.session_log_id">
													{{ $formatDate(session_log.start, 'india') }} - {{
														$formatDate(session_log.end, 'india') }}
												</option>
											</select>
											<span v-if="errors.session_log_id" class="invalid-feedback">{{
												errors.session_log_id[0] }}</span>
										</div>
									</div>
									<div class="col-sm-3">
										<div class="form-group">
											<label for="customer">Customer</label>
											<Customer :initialize="customer_name" @selectCustomer="selectCustomer" />
										</div>
									</div>
									<div class="col-sm-3">
										<div class="form-group" style="margin-top: 26px !important;">
											<button class="btn btn-sm btn-primary mr-2" @click="index">
												<i class="fa fa-search mr-1"></i> Search
											</button>
											<button class="btn btn-sm btn-success mr-2" @click="exportExcel"
												:disabled="transactions.length <= 0">
												<i class="fa fa-file-excel mr-1"></i> Export
											</button>
											<button class="btn btn-sm btn-danger" @click="discard">
												<i class="fa fa-times mr-1"></i> Reset
											</button>
										</div>
									</div>
								</div>
								<div class="table-responsive">
									<table class="table table-responsive-sm table-bordered table-striped table-sm">
										<thead>
											<tr>
												<th class="text-center">#</th>
												<th @click="sort('customer_name')">
													Customer
													<span>
														<i v-if="meta.keyword == 'customer_name' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'customer_name' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th class="text-right" @click="sort('buy_in')" style="cursor: pointer;">
													Total BuyIn
													<span>
														<i v-if="meta.keyword == 'buy_in' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'buy_in' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th class="text-right" @click="sort('deposit')"
													style="cursor: pointer;">
													Total Deposit
													<span>
														<i v-if="meta.keyword == 'deposit' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'deposit' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th class="text-right" @click="sort('cash_out')"
													style="cursor: pointer;">
													Total CashOut
													<span>
														<i v-if="meta.keyword == 'cash_out' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'cash_out' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th class="text-right" @click="sort('withdraw')"
													style="cursor: pointer;">
													Total Withdraw
													<span>
														<i v-if="meta.keyword == 'withdraw' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'withdraw' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th class="text-right" @click="sort('tds_applicable_amount')"
													style="cursor: pointer;">
													Amount Applicable for TDS
													<span>
														<i v-if="meta.keyword == 'tds_applicable_amount' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'tds_applicable_amount' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th class="text-right" @click="sort('tds')" style="cursor: pointer;">
													TDS
													<span>
														<i v-if="meta.keyword == 'tds' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'tds' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(transaction, key) in transactions" :key="key">
												<td class="text-center">{{ meta.from + key }}</td>
												<td>
													<div><strong>{{ transaction.customer?.customer_name }}</strong>
													</div>
													<div>{{ transaction.customer?.customer_no }}</div>
												</td>
												<td class="text-right">{{ formatAmount(transaction.buy_in) }}</td>
												<td class="text-right">{{ formatAmount(transaction.deposit) }}</td>
												<td class="text-right">{{ formatAmount(transaction.cash_out) }}</td>
												<td class="text-right">{{ formatAmount(transaction.withdraw) }}</td>
												<td class="text-right">{{
													formatAmount(transaction.tds_applicable_amount) }}</td>
												<td class="text-right">{{ formatAmount(transaction.tds) }}</td>
											</tr>
											<tr v-if="transactions.length <= 0">
												<td colspan="8" style="text-align: center;">No Records Found</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="card-footer">
								<div class="float-right">
									<Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage"
										:currentPage="meta.page" @pagechanged="onPageChange" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import Customer from "@/components/Customer.vue";
import axios from "axios";

export default {
	name: "TdsReport",
	components: { Pagination, Customer },
	data() {
		return {
			meta: {
				branch_id: this.$store.getters.user?.branch_id || "",
				session_log_id: "",
				customer_id: "",
				search: "",
				order_by: "asc",
				keyword: "customer_name",
				per_page: 10,
				totalRows: 0,
				page: 1,
				lastPage: 1,
				from: 1,
				maxPage: 1,
				totals: null,
			},
			branches: [],
			session_logs: [],
			transactions: [],
			customer_name: "",
			errors: [],
		};
	},
	mounted() {
		let vm = this;
		vm.getBranches();
		if (vm.meta.branch_id) {
			vm.getSessionLogs();
		}
		// Don't auto-load data on mount, wait for user to select branch
	},
	methods: {
		getBranches() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "getBranches" })
				.then(function (response) {
					vm.branches = response.data.data;
				})
				.catch(function (error) {
					vm.errors = error.response?.data?.errors;
					vm.$store.dispatch("error", error.response?.data?.message);
				});
		},

		onBranchChange() {
			let vm = this;
			vm.meta.session_log_id = "";
			vm.meta.page = 1;
			vm.session_logs = [];
			vm.errors = {};
			if (vm.meta.branch_id) {
				vm.getSessionLogs();
			}
		},

		getSessionLogs() {
			let vm = this;
			let data = {
				branch_id: vm.meta.branch_id || vm.$store.getters.user?.branch_id,
			};
			vm.$store
				.dispatch("post", { uri: "getSessionLogs", data: data })
				.then(function (response) {
					// Filter sessions from April 1, 2025 onwards
					const cutoffDate = new Date('2025-04-01');
					cutoffDate.setHours(0, 0, 0, 0);

					vm.session_logs = (response.data.data || []).filter(session => {
						if (!session.start) {
							return false;
						}
						const sessionStartDate = new Date(session.start);
						return sessionStartDate >= cutoffDate;
					});

					// Auto-select the latest session (first one in the array)
					if (vm.session_logs && vm.session_logs.length > 0) {
						vm.meta.session_log_id = vm.session_logs[0].session_log_id;
					} else {
						vm.meta.session_log_id = "";
					}
				})
				.catch(function (error) {
					vm.errors = error.response?.data?.errors;
					vm.$store.dispatch("error", error.response?.data?.message);
				});
		},

		onSessionChange() {
			let vm = this;
			vm.meta.page = 1;
			vm.errors = {};
		},

		selectCustomer(event) {
			let vm = this;
			if (event.target.value) {
				vm.meta.customer_id = event.target.value.customer_id;
				vm.customer_name = event.target.value.customer_no + " - " + event.target.value.customer_name;
			} else {
				vm.meta.customer_id = "";
				vm.customer_name = "";
			}
		},

		index() {
			let vm = this;
			vm.errors = [];

			if (!vm.meta.branch_id) {
				vm.errors = { branch_id: ['Branch is required'] };
				vm.$store.dispatch("error", "Please select a branch");
				return;
			}

			if (!vm.meta.session_log_id) {
				vm.errors = { session_log_id: ['Session is required'] };
				vm.$store.dispatch("error", "Please select a session");
				return;
			}

			let loader = vm.$loading.show();
			vm.$store
				.dispatch("post", { uri: "getTdsReport", data: vm.meta })
				.then(function (response) {
					loader.hide();
					vm.transactions = response.data.data;
					vm.meta.totalRows = response.data.meta.total;
					vm.meta.lastPage = response.data.meta.last_page;
					vm.meta.from = response.data.meta.from;
					vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
					vm.meta.totals = response.data.meta.totals || null;
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response?.data?.errors || {};
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to load TDS report");
				});
		},

		search() {
			let vm = this;
			vm.meta.page = 1;
			vm.index();
		},

		sort(field) {
			this.meta.keyword = field;
			this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
			this.index();
		},

		discard() {
			let vm = this;
			vm.meta.branch_id = this.$store.getters.user?.branch_id || "";
			vm.meta.session_log_id = "";
			vm.meta.customer_id = "";
			vm.meta.search = "";
			vm.meta.page = 1;
			vm.customer_name = "";
			vm.session_logs = [];
			vm.transactions = [];
			vm.errors = [];
			if (vm.meta.branch_id) {
				vm.getSessionLogs();
			}
		},

		onPageChange(page) {
			this.meta.page = page;
			this.index();
		},

		exportExcel() {
			let vm = this;

			if (!vm.meta.branch_id) {
				vm.$store.dispatch("error", "Please select a branch");
				return;
			}

			if (!vm.meta.session_log_id) {
				vm.$store.dispatch("error", "Please select a session");
				return;
			}

			let loader = vm.$loading.show();

			// Use axios for blob download with authentication
			axios
				.post(vm.$store.getters.apiUrl + 'exportTdsReport', vm.meta, {
					headers: {
						Authorization: "Bearer" + " " + vm.$store.getters.token,
					},
					responseType: 'blob' // Important for file downloads
				})
				.then(function (response) {
					loader.hide();
					// Create blob from response
					const blob = new Blob([response.data], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
					});

					// Create download link
					const url = window.URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = url;
					link.download = 'TDS_Report_' + new Date().toISOString().slice(0, 10) + '.xlsx';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					window.URL.revokeObjectURL(url);
				})
				.catch(function (error) {
					loader.hide();
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to export TDS report");
				});
		},

		formatAmount(amount) {
			return Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		},
	},
};
</script>

<style scoped>
.total-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 8px 12px;
	background-color: #f8f9fa;
	border-radius: 6px;
	border: 1px solid #e9ecef;
	min-width: 90px;
	transition: all 0.2s ease;
}

.total-item:hover {
	background-color: #e9ecef;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.total-label {
	font-size: 11px;
	color: #6c757d;
	font-weight: 500;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	margin-bottom: 4px;
	white-space: nowrap;
}

.total-value {
	font-size: 15px;
	font-weight: 700;
	color: #212529;
	line-height: 1.2;
}

.total-value.text-warning {
	color: #ff9800;
}

.total-value.text-danger {
	color: #dc3545;
}

.breadcrumb-centered {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
}

.breadcrumb-centered .breadcrumb-item {
	display: flex;
	align-items: center;
}

.breadcrumb-centered .breadcrumb-right {
	margin-left: auto;
}

@media (max-width: 768px) {
	.total-item {
		min-width: 80px;
		padding: 6px 10px;
	}

	.total-label {
		font-size: 10px;
	}

	.total-value {
		font-size: 13px;
	}
}
</style>
